import React from 'react';
import { PageHeader } from './PageHeader';
import { Reveal } from '../ui/Reveal';
export interface LegalBlock {
  type: 'p' | 'list' | 'h3' | 'links';
  /** External links rendered as a bulleted list (type: 'links'). */
  links?: {
    label: string;
    href: string;
  }[];
  text?: string;
  /** Optional bold lead-in rendered before the paragraph text (e.g. "Talent Agencies:"). */
  label?: string;
  items?: string[];
}
export interface LegalSection {
  heading: string;
  blocks: LegalBlock[];
}
interface LegalLayoutProps {
  title: string;
  subtitle: string;
  updated: string;
  intro?: string | string[];
  sections: LegalSection[];
}
export const LegalLayout = ({
  title,
  subtitle,
  updated,
  intro,
  sections
}: LegalLayoutProps) => {
  return <>
      <PageHeader eyebrow="Legal" title={title} subtitle={subtitle} data-id="element-1456" data-mp="jgs0a54a4974" />

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-24 -mt-4" data-id="element-1457" data-mp="28ux6fmwl0r6y">
        <Reveal data-id="element-1458" data-mp="2dsypw8xx6siy">
          <p className="text-xs font-semibold uppercase tracking-wider text-zano-pink mb-8" data-id="element-1459" data-mp="2drdukh3s75k1">
            Updated {updated}
          </p>

          {intro && <div className="mb-10 space-y-3" data-id="element-1460" data-mp="kh1xqelo3cv7">
              {(Array.isArray(intro) ? intro : [intro]).map((para, i) => <p key={i} className="text-gray-600 leading-relaxed" data-id="element-1461" data-mp="y75fotdikkeu" data-mpi={i}>
                  {para}
                </p>)}
            </div>}

          <div className="space-y-10" data-id="element-1462" data-mp="5jjefrrrdrv5">
            {sections.map((section, i) => <div key={i} data-id="element-1463" data-mp="5lm42ap01izc" data-mpi={i}>
                <h2 className="text-lg font-bold text-zano-charcoal mb-3" data-id="element-1464" data-mp="1i7n9ht8kyku">
                  {i + 1}. {section.heading}
                </h2>
                <div className="space-y-3" data-id="element-1465" data-mp="fja8xtgbk6v8">
                  {section.blocks.map((block, j) => block.type === 'h3' ? <h3 key={j} className="pt-2 text-base font-semibold text-zano-charcoal" data-id="element-1466" data-mp="1qwvvd6usnud2">
                        {block.text}
                      </h3> : block.type === 'links' ? <ul key={j} className="list-disc pl-5 space-y-2 text-gray-600 leading-relaxed" data-id="element-1467" data-mp="1u0jybfcwirpz">
                        {block.links?.map(link => <li key={link.href} data-id="element-1468" data-mp="27yrz5yd26d6f">
                            <a href={link.href} target="_blank" rel="noopener noreferrer" className="font-medium text-zano-pink underline-offset-2 hover:underline" data-id="element-1469" data-mp="27xqdkzyf28ag">
                              {link.label}
                            </a>
                          </li>)}
                      </ul> : block.type === 'list' ? <ul key={j} className="list-disc pl-5 space-y-2 text-gray-600 leading-relaxed" data-id="element-1470" data-mp="ri5uswmmco56">
                        {block.items?.map((item, k) => <li key={k} data-id="element-1471" data-mp="jzxz7fmijq1j">{item}</li>)}
                      </ul> : <p key={j} className="text-gray-600 leading-relaxed" data-id="element-1472" data-mp="f035z5f9modb">
                        {block.label && <strong className="font-semibold text-zano-charcoal" data-id="element-1473" data-mp="a21p8r5bb150">
                            {block.label}{' '}
                          </strong>}
                        {block.text}
                      </p>)}
                </div>
              </div>)}
          </div>
        </Reveal>
      </section>
    </>;
};